import StoreButtons from "@/components/site/StoreButtons";
import { Reveal } from "@/components/site/Reveal";

export default function FinalCta({ settings }) {
  return (
    <section data-testid="final-cta-section" className="relative overflow-hidden pt-14 pb-16 text-center">
      <div
        className="pointer-events-none absolute -bottom-[350px] left-1/2 -translate-x-1/2 w-[900px] h-[600px]"
        style={{ background: "radial-gradient(ellipse, rgba(238,101,51,.12), transparent 65%)" }}
      />
      <div className="relative mx-auto w-[min(900px,calc(100%-32px))]">
        <Reveal>
          <h2 className="headline text-4xl sm:text-5xl lg:text-6xl mb-6">
            <span className="text-white">Don't just </span>
            <span className="text-ember">follow a workout</span>
            <br />
            <span className="text-forge">Forge your own</span>
          </h2>
          <p className="text-white/50 text-sm md:text-base mb-11">Create Roll Move Build your path</p>
          <div className="flex justify-center">
            <StoreButtons settings={settings} testIdPrefix="cta-store" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
